var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-base',{attrs:{"id":String(_vm.id),"category":"サイバー空間の脅威に立ち向かえ！","routerName":"FaceUp"}})}
var staticRenderFns = []

export { render, staticRenderFns }